import { create } from 'zustand';

import { getErrorMessage } from '#lib/errors/errorMessages';

export const useErrorStore = create((set) => ({
	notification: null,

	showError: (options) => {
		const message = options.error ? getErrorMessage(options.error) : options.message;
		set({
			notification: {
				type: 'error',
				title: options.title || 'Fehler aufgetreten',
				message,
				actionButton: options.actionButton,
				autoClose: options.autoClose || false,
				autoCloseDuration: options.autoCloseDuration || 5000,
				validationErrors: options.error?.validationErrors ?? null,
			},
		});
	},

	showWarning: (options) =>
		set({
			notification: {
				type: 'warning',
				title: options.title || 'Warnung',
				message: options.message,
				actionButton: options.actionButton,
				autoClose: options.autoClose || false,
				autoCloseDuration: options.autoCloseDuration || 5000,
			},
		}),

	showInfo: (options) =>
		set({
			notification: {
				type: 'info',
				title: options.title || 'Information',
				message: options.message,
				actionButton: options.actionButton,
				autoClose: options.autoClose || false,
				autoCloseDuration: options.autoCloseDuration || 5000,
			},
		}),

	showSuccess: (options) =>
		set({
			notification: {
				type: 'success',
				title: options.title || 'Erfolgreich',
				message: options.message,
				actionButton: options.actionButton,
				autoClose: options.autoClose !== false,
				autoCloseDuration: options.autoCloseDuration || 5000,
			},
		}),

	closeNotification: () => set({ notification: null }),
}));
